/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiReorderChannelsInputFromJSON, ApiReorderChannelsInputToJSON, } from './ApiReorderChannelsInput';
export function ApiReorderChannelsPayloadFromJSON(json) {
    return ApiReorderChannelsPayloadFromJSONTyped(json, false);
}
export function ApiReorderChannelsPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'input': !exists(json, 'input') ? undefined : (json['input'].map(ApiReorderChannelsInputFromJSON)),
    };
}
export function ApiReorderChannelsPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'input': value.input === undefined ? undefined : (value.input.map(ApiReorderChannelsInputToJSON)),
    };
}
